import { initAnalytics } from "@pex/analytics/client";

initAnalytics({ appName: "register" });
